<script setup lang="ts">
import { Analytics as VercelAnalytics } from "@vercel/analytics/nuxt";
import { SpeedInsights } from "@vercel/speed-insights/nuxt";
</script>

<template>
  <NuxtLayout>
    <VercelAnalytics />
    <SpeedInsights />
    <NuxtPage />
  </NuxtLayout>
</template>
